import { makeStyles, shorthands } from '@fluentui/react-components';
import { corptaxThemeTokens } from '../../theme';
import { INavigationItem } from '../../view-models/navigation/INavigationItem';
import LinkIcon from './LinkIcon';

export interface INavRailProps {
    items: Array<INavigationItem>;
}

const useStyles = makeStyles({
    nav: {
        display: 'block',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        wordWrap: 'break-word',
        maxWidth: '4.7rem',
        fontSize: '.625rem',
        backgroundColor: corptaxThemeTokens.colorBrandBackground,
        color: corptaxThemeTokens.colorNeutralForegroundOnBrand,
    },
    ul: {
        height: '100%',
        width: '100%',
        listStyleType: 'none',
        paddingTop: '10px',
        paddingBottom: '10px',
        paddingLeft: '0',
        paddingRight: '0',
        ...shorthands.margin('0'),
        display: 'inline-flex',
        flexDirection: 'column',
        rowGap: '1rem',
        backgroundColor: corptaxThemeTokens.colorBrandBackground,
        color: corptaxThemeTokens.colorNeutralForegroundOnBrand,
        '& a': {
            textDecorationLine: 'none',
            color: corptaxThemeTokens.colorNeutralForegroundOnBrand,
            display: 'inline-block' /* because focus indicator */,
        },
        '& li': {
            textAlign: 'center',
            wordWrap: 'break-word',
        },
        '& li > a > div': {
            lineHeight: '1.2rem',
        },
    },
});

// note: this component requires Fluent V9
export const NavRail = (props: INavRailProps) => {
    // this doesn't take into account groups or anything yet
    const classes = useStyles();

    return (
        <nav className={classes.nav}>
            <ul className={classes.ul} aria-label={'navigation list'}>
                {props.items?.map((item) => {
                    return (
                        <li key={item.id}>
                            <a href={item.routeUrl}>
                                <LinkIcon iconName={item.iconName} />
                                <div>{item.displayName}</div>
                            </a>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};
